export const headingClasses = 'text-primary text-base font-semibold zappos:font-normal';
